import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  CanAuthenticationGuard,
  AccessRightExchangeManagement,
  BlockPageAuthGuard,
} from '../../../utils/authguard';
import { SharemailboxComponent } from './sharemailbox.component';
import { SharemailboxDeleteConfirmComponent } from './sharemailbox-delete-confirm/sharemailbox-delete-confirm.component';
import { SharemailboxAddDialogComponent } from './sharemailbox-add-dialog/sharemailbox-add-dialog.component';
import { MaterialModule } from 'src/app/material/material.module';
import { MatStepperModule } from '@angular/material/stepper';
import { ErrorMessageComponent } from '../../shared/error-message/error-message.component';
import { ExchangePageComponent } from '../../shared/exchange-page/exchange-page.component';

const routes = [
  {
    path: 'exchange/sharemailbox',
    component: SharemailboxComponent,
    canActivate: [
      CanAuthenticationGuard,
      AccessRightExchangeManagement,
      BlockPageAuthGuard,
    ],
  },
];

@NgModule({
  declarations: [
    SharemailboxComponent,
    SharemailboxAddDialogComponent,
    SharemailboxDeleteConfirmComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    MaterialModule,
    MatStepperModule,
    ErrorMessageComponent,
    ExchangePageComponent,
  ],
  exports: [SharemailboxComponent],
  providers: [CanAuthenticationGuard],
})
export class SharemailboxModule {}